import { render } from "./HeroSection.vue?vue&type=template&id=0ecd1c5d&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=0ecd1c5d&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd1c5d"]])

export default __exports__